module.exports = __webpack_public_path__ + "static/media/laptop.ff7a221f.svg";